import { PropsWithChildren, useCallback, useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { AppInput } from './AppInput'
import { resetPaginationByParamsChanged } from '../../utils/resetPaginationByParamsChanged'

export interface IAppFilterInput {
  searchParam: string
  placeholder?: string
  label?: string
  shouldResetPagination?: boolean
  maxValue?: string
  minValue?: string
  fullWidth?: boolean
}

export const AppFilterTimeInput = ({
  searchParam,
  label,
  placeholder,
  shouldResetPagination = true,
  maxValue,
  minValue,
  fullWidth,
}: PropsWithChildren<IAppFilterInput>) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [state, setState] = useState(searchParams.get(searchParam))
  const { pathname } = useLocation()

  const currentSearchParamValue = searchParams.get(searchParam) as string

  useEffect(() => {
    if (!!currentSearchParamValue) {
      setState(!!currentSearchParamValue ? currentSearchParamValue : '')
    } else {
      setState('')
    }
  }, [currentSearchParamValue])

  const changeHandler = useCallback(
    (value: string) => {
      if (!!value) {
        setState(value)
        searchParams.set(searchParam, value)
      } else {
        setState('')
        searchParams.delete(searchParam)
      }
      setSearchParams(searchParams.toString(), { replace: true })
      if (shouldResetPagination) {
        resetPaginationByParamsChanged({
          searchParams,
          setSearchParams,
          pathname,
        })
      }
    },
    [searchParams, setSearchParams, searchParam],
  )

  return (
    <AppInput
      value={state}
      onChange={changeHandler}
      label={label}
      placeholder={placeholder}
      type={'time'}
      fullWidth={fullWidth}
      maxValue={maxValue}
      minValue={minValue}
      timeWithList
    />
  )
}
